const dashboard = {
  // Page-level
  "dashboard.title": "لوحة التحكم",
  "dashboard.connectPrompt": "قم بتوصيل واتساب للبدء",
  "dashboard.session": "الجلسة",
  "dashboard.plan": "الخطة",
  "dashboard.loading": "جاري تحميل لوحة التحكم...",
  "dashboard.error.title": "فشل تحميل البيانات",
  "dashboard.error.needReconnect": "تحتاج جلسة واتساب إلى إعادة اتصال. إعادة المسح ستسمح لك بمسح كود QR جديد.",
  "dashboard.error.restartScan": "إعادة المسح",
  "dashboard.tabs.overview": "نظرة عامة",
  "dashboard.tabs.automation": "الأتمتة",
  "dashboard.tabs.knowledge": "قاعدة المعرفة",
  "dashboard.tabs.blacklist": "القائمة السوداء",
  "dashboard.tabs.whatsapp": "واتساب",
  "dashboard.quickInfo.plan": "الخطة",
  "dashboard.quickInfo.session": "الجلسة",
  "dashboard.quickInfo.csvRows": "صفوف CSV",
  "dashboard.quickInfo.blacklisted": "محظور",
  "dashboard.toast.disconnected": "انقطع اتصال واتساب. جاري إعادة المسح...",
  "dashboard.quickInfo.title": "معلومات سريعة",

  // StatsCards
  "stats.totalUsage": "إجمالي الاستخدام",
  "stats.averageUsage": "متوسط الاستخدام عبر جميع الموارد",
  "stats.trendingUp": "استخدامك الإجمالي في ارتفاع. فكر في الترقية قريباً.",
  "stats.trendingDown": "استخدامك الإجمالي في انخفاض.",
  "stats.trendingFlat": "استخدامك الإجمالي مستقر.",
  "stats.exceededLimit": " لقد تجاوزت حد خطتك في بعض الموارد. ",
  "stats.upgradePrompt": "قم بترقية خطتك لزيادة الحدود.",
  "stats.messages": "الرسائل",
  "stats.tokens": "الرموز",
  "stats.inputTokens": "الرموز المدخلة",
  "stats.outputTokens": "الرموز المخرجة",
  "stats.of": "من",
  "stats.usageStatistics": "إحصائيات الاستخدام",
  "stats.last7Days": "اتجاه آخر 7 أيام",

  // ChatListSidebar
  "chatList.title": "المحادثات",
  "chatList.bulkMessage": "رسالة جماعية",
  "chatList.crmPipeline": "CRM Pipeline",
  "chatList.refreshChats": "تحديث المحادثات",
  "chatList.searchPlaceholder": "ابحث أو ابدأ محادثة جديدة",
  "chatList.filterAll": "الكل",
  "chatList.filterUnread": "غير مقروء",
  "chatList.filterGroups": "المجموعات",
  "chatList.tryAgain": "حاول مرة أخرى",
  "chatList.noChats": "لا توجد محادثات بعد",
  "chatList.you": "أنت",
  "chatList.yesterday": "أمس",
  "chatList.archived": "المؤرشفة",
  "chatList.photo": "صورة",
  "chatList.video": "فيديو",
  "chatList.voiceMessage": "رسالة صوتية",
  "chatList.audio": "صوت",
  "chatList.document": "مستند",
  "chatList.location": "موقع",
  "chatList.sticker": "ملصق",
  "chatList.contact": "جهة اتصال",
  "chatList.poll": "استطلاع",
  "chatList.gif": "GIF",
  "chatList.product": "منتج",
  "chatList.call": "مكالمة",
  "chatList.catalog": "كتالوج",
  "chatList.order": "طلب",
  "chatList.template": "قالب",
  "chatList.button": "زر",
  "chatList.interactiveMessage": "رسالة تفاعلية",
  "chatList.disappearingMessage": "رسالة مؤقتة",
  "chatList.groupEvent": "حدث مجموعة",
  "chatList.notification": "إشعار",
  "chatList.broadcast": "بث",

  // ChatWindow
  "chatWindow.title": "محادثة واتساب",
  "chatWindow.emptyText": "اختر محادثة من القائمة لبدء الدردشة. الرسائل تحدث في الوقت الفعلي.",
  "chatWindow.group": "مجموعة",
  "chatWindow.business": "تجاري",
  "chatWindow.refreshMessages": "تحديث الرسائل",
  "chatWindow.today": "اليوم",
  "chatWindow.yesterday": "أمس",
  "chatWindow.noMessages": "لا توجد رسائل بعد",
  "chatWindow.startConversation": "أرسل رسالة لبدء المحادثة",
  "chatWindow.back": "رجوع",

  // ChatInput
  "chatInput.aiReplying": "الذكاء الاصطناعي يولد رداً...",
  "chatInput.shareLocation": "مشاركة الموقع",
  "chatInput.locationName": "اسم الموقع *",
  "chatInput.address": "العنوان",
  "chatInput.latitude": "خط العرض *",
  "chatInput.longitude": "خط الطول *",
  "chatInput.sending": "جاري الإرسال...",
  "chatInput.sendLocation": "إرسال الموقع",
  "chatInput.shareLink": "مشاركة رابط",
  "chatInput.url": "الرابط *",
  "chatInput.captionOptional": "تعليق (اختياري)",
  "chatInput.sendLink": "إرسال الرابط",
  "chatInput.recordVoice": "تسجيل صوتي",
  "chatInput.attach": "مرفقات",
  "chatInput.typeMessage": "اكتب رسالة",

  // WhatsAppSessionPanel
  "wpp.readyToConnect": "جاهز للاتصال",
  "wpp.generatingToken": "جاري إنشاء الرمز...",
  "wpp.tokenGenerated": "تم إنشاء الرمز",
  "wpp.startingSession": "جاري بدء الجلسة...",
  "wpp.waitingForQR": "في انتظار مسح QR",
  "wpp.sessionConnected": "الجلسة متصلة",
  "wpp.connectionError": "خطأ في الاتصال",
  "wpp.stepToken": "الرمز",
  "wpp.stepQR": "كود QR",
  "wpp.stepConnected": "متصل",
  "wpp.noSession": "لا توجد جلسة متاحة. الرجاء تسجيل الدخول أولاً.",
  "wpp.title": "جلسة واتساب",
  "wpp.sessionLabel": "الجلسة:",
  "wpp.statusConnected": "متصل",
  "wpp.statusWaiting": "في الانتظار",
  "wpp.statusGenerating": "جاري التوليد",
  "wpp.statusStarting": "جاري البدء",
  "wpp.statusChecking": "جاري الفحص",
  "wpp.reset": "إعادة تعيين",
  "wpp.connectPrompt": "قم بإنشاء رمز وابدأ جلسة واتساب لتوصيل رقمك.",
  "wpp.connectBtn": "توصيل واتساب",
  "wpp.generatingDesc": "جاري إنشاء رمز آمن...",
  "wpp.generatingSub": "الاتصال بالخادم للمصادقة",
  "wpp.startingDesc": "جاري بدء جلسة واتساب...",
  "wpp.startingSub": "تهيئة الاتصال",
  "wpp.tokenReady": "تم إنشاء الرمز بنجاح",
  "wpp.startSession": "بدء الجلسة",
  "wpp.scanTitle": "امسح باستخدام واتساب",
  "wpp.scanDesc": "افتح واتساب على هاتفك، اذهب إلى <strong>الإعدادات &gt; الأجهزة المرتبطة</strong>، وامسح كود QR هذا.",
  "wpp.checkNow": "تحقق الآن",
  "wpp.startOver": "البدء من جديد",
  "wpp.autoCheck": "جاري التحقق التلقائي كل 5 ثوانٍ...",
  "wpp.connectedTitle": "واتساب متصل",
  "wpp.connectedDesc": "جلستك {{name}} نشطة وجاهزة.",
  "wpp.verifyConnection": "التحقق من الاتصال",
  "wpp.errorTitle": "خطأ",

  // AutomationPanel
  "automation.title": "إعدادات الأتمتة",
  "automation.statusUpdated": "تم تحديث الحالة!",
  "automation.failedUpdate": "فشل التحديث",
  "automation.statusTitle": "حالة الأتمتة",
  "automation.statusActive": "البوت يرد تلقائياً على الرسائل",
  "automation.statusPaused": "البوت متوقف مؤقتاً حالياً",
  "automation.lastUpdated": "آخر تحديث:",
  "automation.replySettings": "إعدادات الرد",
  "automation.replySettingsUpdated": "تم تحديث إعدادات الرد!",
  "automation.voiceMessages": "الرسائل الصوتية",
  "automation.voiceDesc": "رد تلقائي برسائل صوتية",
  "automation.imageReplies": "الردود بالصور",
  "automation.imageDesc": "رد تلقائي بالصور",
  "automation.documentReplies": "الردود بالمستندات",
  "automation.documentDesc": "رد تلقائي بالمستندات",

  // KnowledgeBasePanel
  "kb.title": "قاعدة المعرفة",
  "kb.subtitle": "معلومات العمل + {{products}} منتج{{plural}} مجمعة في data.csv واحد",
  "kb.businessSection": "معلومات العمل",
  "kb.businessDesc": "ملف الشركة وتفاصيل الخدمات",
  "kb.productSection": "معلومات المنتجات",
  "kb.productDesc": "أضف منتجات لقاعدة المعرفة",
  "kb.productDescWithCount": "{{count}} منتج{{plural}} · {{fields}} حقل مملوء",
  "kb.importCsv": "استيراد عبر CSV",
  "kb.addProduct": "إضافة منتج",
  "kb.submitCsv": "إرسال كـ data.csv",
  "kb.submitting": "جاري الإرسال...",
  "kb.fillRequired": "املأ حقل واحد على الأقل قبل الإرسال",
  "kb.submitSuccess": "تم الإرسال! {{fields}} حقل عبر {{sections}} أقسام تم إرسالها كـ data.csv ({{rows}} صف).",
  "kb.submitFailed": "فشل الإرسال",
  "kb.fieldsFilled": "{{total}} حقل مملوء عبر {{sections}} أقسام",
  "kb.fieldsCount": "{{filled}}/{{total}} حقل",
  "kb.removeProduct": "حذف المنتج",
  "kb.productDefault": "منتج {{index}}",
  // Business fields
  "kb.field.name": "اسم العمل",
  "kb.field.namePlaceholder": "اسم الشركة أو العمل",
  "kb.field.industry": "المجال",
  "kb.field.industryPlaceholder": "مثال: تطوير البرمجيات والحلول الرقمية",
  "kb.field.description": "الوصف",
  "kb.field.descriptionPlaceholder": "وصف مختصر للعمل",
  "kb.field.email": "البريد الإلكتروني",
  "kb.field.emailPlaceholder": "contact@example.com",
  "kb.field.website": "الموقع الإلكتروني",
  "kb.field.websitePlaceholder": "https://example.com",
  "kb.field.workingHours": "ساعات العمل",
  "kb.field.workingHoursPlaceholder": "مثال: يومياً من 9 صباحاً حتى 5 مساءً",
  "kb.field.address": "العنوان",
  "kb.field.addressPlaceholder": "العنوان الفعلي",
  "kb.field.serviceMonthly": "الخدمة الشهرية",
  "kb.field.serviceMonthlyPlaceholder": "وصف عروض الخدمة الشهرية",
  "kb.field.serviceQuarterly": "الخدمة الربع سنوية",
  "kb.field.serviceQuarterlyPlaceholder": "وصف عروض الخدمة الربع سنوية",
  "kb.field.serviceTrainer": "خدمة التدريب",
  "kb.field.serviceTrainerPlaceholder": "وصف عروض التدريب",
  // Product fields
  "kb.field.productName": "اسم المنتج",
  "kb.field.productNamePlaceholder": "مثال: سماعات بلوتوث لاسلكية برو X200",
  "kb.field.productDescription": "الوصف",
  "kb.field.productDescriptionPlaceholder": "وصف مفصل للمنتج",
  "kb.field.category": "الفئة",
  "kb.field.categoryPlaceholder": "مثال: إلكترونيات، أزياء، منزل وحديقة",
  "kb.field.brand": "العلامة التجارية",
  "kb.field.brandPlaceholder": "مثال: آبل، سامسونج، نايك",
  "kb.field.price": "السعر",
  "kb.field.pricePlaceholder": "مثال: 299.99",
  "kb.field.features": "المميزات الرئيسية",
  "kb.field.featuresPlaceholder": "المميزات والمواصفات الرئيسية مفصولة بفواصل",
  "kb.field.inventoryStatus": "حالة المخزون",
  "kb.field.inventoryStatusPlaceholder": "مثال: متوفر، غير متوفر، طلب مسبق",
  "kb.field.productUrl": "رابط المنتج",
  "kb.field.productUrlPlaceholder": "https://example.com/product",

  // BlacklistPanel
  "blacklist.title": "القائمة السوداء",
  "blacklist.addNumber": "إضافة رقم",
  "blacklist.phonePlaceholder": "أدخل رقم الهاتف (مثال: 201234567890)",
  "blacklist.block": "حظر",
  "blacklist.invalidPhone": "أدخل رقم هاتف صحيح (10-15 رقم، بدون +)",
  "blacklist.addedSuccess": "تمت إضافة الرقم إلى القائمة السوداء",
  "blacklist.addedFailed": "فشل إضافة الرقم",
  "blacklist.removedSuccess": "تمت إزالة الرقم",
  "blacklist.removedFailed": "فشل إزالة الرقم",
  "blacklist.empty": "القائمة السوداء فارغة. جميع الأرقام يمكنها التفاعل مع البوت.",
  "blacklist.blockedCount": "الأرقام المحظورة: {{count}}",

  // BulkMessagingPanel
  "bulk.title": "الرسائل الجماعية",
  "bulk.messageComposer": "محرر الرسالة",
  "bulk.simple": "بسيط",
  "bulk.advanced": "متقدم",
  "bulk.messagePlaceholder": "مرحباً {{name}}! لدينا عرض حصري لك...",
  "bulk.charCount": "{{{count}}} / 4096",
  "bulk.insertVariables": "أدخل متغيرات ديناميكية لتخصيص الرسائل",
  "bulk.name": "الاسم",
  "bulk.phone": "الهاتف",
  "bulk.attach": "مرفقات",
  "bulk.delayTitle": "التأخير بين الرسائل",
  "bulk.delayDesc": "يقلل من خطر اكتشاف البريد العشوائي. موصى به: 5-15 ثانية",
  "bulk.sec": "ثانية",
  "bulk.randomDelay": "تأخير عشوائي",
  "bulk.scheduleTitle": "جدولة الإرسال",
  "bulk.date": "التاريخ",
  "bulk.time": "الوقت",
  "bulk.campaignScheduled": "تمت جدولة الحملة",
  "bulk.preview": "معاينة",
  "bulk.previewEmpty": "ستظهر رسالتك هنا...",
  "bulk.justNow": "الآن",
  "bulk.contacts": "جهات الاتصال",
  "bulk.contactsFormat": "صيغة الهاتف، الاسم",
  "bulk.importCsv": "استيراد CSV",
  "bulk.clearAll": "مسح الكل",
  "bulk.sendAll": "إرسال الكل",
  "bulk.stopSending": "إيقاف الإرسال",
  "bulk.scheduleSend": "جدولة الإرسال",
  "bulk.sendingMessages": "جاري إرسال الرسائل...",
  "bulk.noContacts": "لا توجد جهات اتصال",
  "bulk.importPrompt": "استورد CSV أو قم بتوصيل واتساب لتحميل جهات الاتصال",
  "bulk.scheduledBanner": "يبدأ الإرسال {{date}}، {{time}}",
  "bulk.recipientsWillReceive": "{{count}} جهة اتصال{{plural}} ستستلم الرسالة",
  "bulk.cancel": "إلغاء",
  "bulk.all": "الكل",
  "bulk.pending": "قيد الانتظار",
  "bulk.sent": "تم الإرسال",
  "bulk.failed": "فشل",
  "bulk.nameColumn": "الاسم",
  "bulk.phoneColumn": "الهاتف",
  "bulk.statusColumn": "الحالة",
  "bulk.backToChats": "العودة للمحادثات",
  "bulk.mobileTabMessage": "الرسالة",
  "bulk.mobileTabContacts": "جهات الاتصال",
  "bulk.csvImportSuccess": "تم استيراد {{count}} جهة{{plural}}",
  "bulk.csvDuplicates": "تم تخطي {{count}} مكرر{{plural}}",
  "bulk.csvNoPhone": "{{count}} صف{{plural}} بدون هاتف",
  "bulk.csvNoNew": "لم تتم إضافة جهات اتصال جديدة.",
  "bulk.csvInvalidType": "نوع ملف غير صالح. الرجاء رفع ملف .csv.",
  "bulk.csvTooLarge": "الملف كبير جداً ({{size}}ميجابايت). الحد الأقصى 5 ميجابايت.",
  "bulk.csvReadError": "فشل قراءة الملف. تأكد أنه ملف CSV صالح.",
  "bulk.csvNoData": "لم يتم العثور على صفوف بيانات صالحة في الملف.",
  "bulk.csvNoHeaders": "لم يتم العثور على عناوين صالحة.",
  "bulk.csvHeadersOnly": "الملف يحتوي على عناوين فقط — لا توجد صفوف بيانات.",
  "bulk.csvColumnMismatch": "صف {{row}}: متوقع {{expected}} عمود، تم استلام {{got}}. تم تخطي الصف.",
  "bulk.csvEmpty": "الملف فارغ.",
  "bulk.pagination": "{{start}}-{{end}} من {{total}}",
  "bulk.scheduleTimeFuture": "يجب أن يكون وقت الجدولة في المستقبل.",
  "bulk.failedToSend": "فشل إرسال الرسالة",
  "bulk.switchFixedDelay": "تبديل للتأخير الثابت",
  "bulk.switchRandomDelay": "تبديل للتأخير العشوائي",
  "bulk.switchSendNow": "تبديل للإرسال الفوري",
  "bulk.switchSchedule": "تفعيل جدولة الإرسال",
  "bulk.cancelSchedule": "إلغاء الجدولة",
  "bulk.stopSendingTooltip": "إيقاف الإرسال",
  "bulk.mobileRecipients": "{{{count}}} جهة - {{{status}}}",
  "bulk.statusPending": "قيد الانتظار",
  "bulk.statusSent": "تم الإرسال",
  "bulk.statusFailed": "فشل",

  // MessageBubble
  "msg.photo": "صورة",
  "msg.video": "فيديو",
  "msg.audio": "صوت",
  "msg.voiceMessage": "رسالة صوتية",
  "msg.document": "مستند",
  "msg.location": "موقع",
  "msg.sticker": "ملصق",
  "msg.contact": "جهة اتصال",
  "msg.link": "رابط",
  "msg.deleted": "تم حذف هذه الرسالة",
  "msg.you": "أنت",
  "msg.loadingImage": "جاري تحميل الصورة...",
  "msg.imageUnavailable": "الصورة غير متاحة",
  "msg.image": "صورة",
  "msg.loadingVideo": "جاري تحميل الفيديو...",
  "msg.videoUnavailable": "الفيديو غير متاح",
  "msg.tapToOpenMap": "اضغط لفتح الخريطة",
  "msg.openInMaps": "فتح في الخرائط",
  "msg.file": "ملف",
  "msg.documentType": "مستند",
  "msg.voiceCall": "مكالمة صوتية",
  "msg.videoCall": "مكالمة فيديو",
  "msg.tapToCallBack": "اضغط للاتصال مرة أخرى",
  "msg.contactCard": "بطاقة جهة اتصال",

  // MessageActions
  "actions.reply": "رد",
  "actions.aiReply": "اقترح رد",
  "actions.copy": "نسخ",
  "actions.react": "تفاعل",
  "actions.cancel": "إلغاء",

  // AttachmentMenu
  "attach.image": "صورة",
  "attach.document": "مستند",
  "attach.location": "موقع",
  "attach.link": "رابط",

  // VoiceRecorder
  "voice.delete": "حذف",
  "voice.connecting": "جاري الاتصال...",
  "voice.resume": "استئناف",
  "voice.pause": "إيقاف",
  "voice.send": "إرسال",

  // ReplyPreview
  "reply.replyTo": "الرد على",

  // CsvProductImporter
  "csvImporter.title": "استيراد المنتجات عبر CSV",
  "csvImporter.subtitle": "استيراد دفعة من المنتجات إلى قاعدة المعرفة",
  "csvImporter.expectedColumns": "الأعمدة المتوقعة",
  "csvImporter.column": "العمود",
  "csvImporter.required": "مطلوب",
  "csvImporter.optional": "اختياري",
  "csvImporter.example": "مثال",
  "csvImporter.requiredBadge": "مطلوب",
  "csvImporter.optionalBadge": "اختياري",
  "csvImporter.validationTitle": "قواعد التحقق",
  "csvImporter.valRequired": "اسم المنتج ووصف المنتج <strong>مطلوبان</strong> — سيتم تخطي الصفوف التي تفتقر إليهما",
  "csvImporter.valEmptyRows": "يتم تجاهل الصفوف الفارغة تلقائياً",
  "csvImporter.valPrice": "يجب أن يكون السعر رقماً صالحاً (مثال: 299.99)",
  "csvImporter.valDuplicates": "يتم اكتشاف المنتجات المكررة (بالاسم) وتخطيها",
  "csvImporter.valEncoding": "يدعم ترميز UTF-8 للعربية واللغات الأخرى",
  "csvImporter.valTrim": "يتم إزالة المسافات الزائدة من بداية ونهاية كل حقل",
  "csvImporter.downloadTemplate": "تحميل قالب CSV نموذجي",
  "csvImporter.dropHere": "أسقط الملف هنا",
  "csvImporter.clickToUpload": "انقر للرفع أو اسحب وأفلت",
  "csvImporter.csvOnly": "ملفات CSV فقط، يوصى بترميز UTF-8",
  "csvImporter.processing": "جاري معالجة ملف CSV...",
  "csvImporter.validating": "التحقق من البيانات والبحث عن الأخطاء",
  "csvImporter.rowsRead": "صفوف مقروءة",
  "csvImporter.imported": "تم الاستيراد",
  "csvImporter.failed": "فشل",
  "csvImporter.errorsTitle": "أخطاء الاستيراد ({{count}})",
  "csvImporter.fileError": "ملف",
  "csvImporter.rowError": "صف {{row}}",
  "csvImporter.readyTitle": "منتجات جاهزة للاستيراد ({{count}})",
  "csvImporter.uploadAnother": "رفع ملف آخر",
  "csvImporter.cancel": "إلغاء",
  "csvImporter.importBtn": "استيراد {{count}} منتج{{plural}}",
  "csvImporter.invalidFileType": "نوع ملف غير صالح. الرجاء رفع ملف .csv.",
  "csvImporter.noHeaderColumns": "لم يتم التعرف على أعمدة منتجات في العنوان. يرجى التحقق من أسماء الأعمدة.",
  "csvImporter.missingRequiredCols": "يجب أن يتضمن ملف CSV على الأقل عمودي 'Product Name' و 'Product Description'.",
  "csvImporter.missingName": "اسم المنتج مطلوب ومفقود.",
  "csvImporter.missingDesc": "\"{{name}}\" يفتقد وصف المنتج، وهو مطلوب.",
  "csvImporter.invalidPrice": "\"{{name}}\" لديه سعر غير صالح: \"{{price}}\". يجب أن يكون رقماً صالحاً.",
  "csvImporter.duplicate": "\"{{name}}\" موجود بالفعل في قائمة المنتجات. تم تخطي المكرر.",
  "csvImporter.dupInCsv": "\"{{name}}\" يظهر عدة مرات في ملف CSV. تم تخطي المكرر.",
  "csvImporter.readFailed": "فشل قراءة الملف. تأكد أنه ملف CSV صالح بترميز UTF-8.",

  // Charts
  "charts.usageTrends": "اتجاهات الاستخدام",
  "charts.last30Days": "آخر 30 يوماً · الرموز والرسائل",
  "charts.tokens": "الرموز",
  "charts.messages": "الرسائل",
  "charts.input": "المدخلات",
  "charts.output": "المخرجات",
  "charts.tokenSplit": "توزيع الرموز",
  "charts.inputVsOutput": "توزيع المدخلات مقابل المخرجات",
  "charts.inputRatio": "نسبة المدخلات",
  "charts.planCapacity": "سعة الخطة",
  "charts.usageVsLimits": "الاستخدام مقابل الحدود لكل ميزة",
  "charts.used": "مستخدم",
  "charts.dailyActivity": "النشاط اليومي",
  "charts.inputOutputPerDay": "الرموز المدخلة والمخرجة يومياً",
  "charts.activityCalendar": "تقويم النشاط",
  "charts.activitySubtitle": "{{messages}} رسالة · {{days}} يوم نشط · آخر 4 أسابيع",
  "charts.less": "أقل",
  "charts.more": "أكثر",
  "charts.buildingHistory": "جاري بناء سجل النشاط",
  "charts.buildingHistoryDesc": "تتراكم البيانات في كل مرة تزور فيها لوحة التحكم. عد غداً لرؤية أول اتجاه لك!",
  "charts.activeDays": "الأيام النشطة",
  "charts.of28": "{{days}} من 28",
  "charts.avgDaily": "المتوسط اليومي",
  "charts.avgDailyMsgs": "{{msgs}} رسالة",

  // CRM Pipeline
  "crm.title": "CRM Pipeline",
  "crm.tracked": "مُتابع",
  "crm.all": "الكل",
  "crm.noChats": "لا توجد محادثات. انتقل إلى تبويب واتساب لتحميل المحادثات أولاً.",
  "crm.untracked": "غير مُتابع",
  "crm.moveTo": "نقل إلى مرحلة",
  "crm.tags": "وسوم",
  "crm.manageStage": "إدارة المرحلة",
  "crm.addToLeadNew": "إضافة كـ Lead جديد",
  "crm.emptyStage": "لا توجد جهات اتصال في هذه المرحلة بعد",
  "crm.setupTitle": "إعداد CRM Pipeline",
  "crm.setupDesc": "أنشئ تصنيفات واتساب لتتبع عملاءك خلال مراحل البيع — من العميل الجديد إلى العميل المغلق. هذا إعداد لمرة واحدة فقط.",
  "crm.settingUp": "جاري الإعداد...",
  "crm.setupBtn": "إنشاء تصنيفات الـ Pipeline",
  "crm.confirmSetup": "إنشاء تصنيفات الـ Pipeline؟",
  "crm.confirmSetupDesc": "سيتم إنشاء {{count}} تصنيف على جلسة واتساب: Lead جديد، قيد التواصل، تفاوض، عميل، مفقود — بالإضافة إلى وسوم VIP وشكوى.",
  "crm.cancel": "إلغاء",
  "crm.createLabels": "إنشاء التصنيفات",
  "crm.refreshLabels": "تحديث التصنيفات",
  "crm.reset": "إعادة تعيين",
  "crm.resetTitle": "إعادة تعيين الـ Pipeline؟",
  "crm.resetDesc": "سيؤدي هذا إلى حذف جميع تصنيفات CRM من واتساب ومسح بيانات التتبع المحلية. لا يمكن التراجع عن هذا الإجراء.",
  "crm.confirmReset": "حذف جميع التصنيفات",
  "crm.stage.leadnew": "Lead جديد",
  "crm.stage.incontact": "قيد التواصل",
  "crm.stage.negotiating": "تفاوض",
  "crm.stage.customer": "عميل",
  "crm.stage.lost": "مفقود",
  "crm.addCustomer": "إضافة عميل",
  "crm.addCustomerTitle": "إضافة عميل جديد",
  "crm.addCustomerDesc": "أضف عميل غير موجود في المحادثات بعد لتتبعه في الـ Pipeline.",
  "crm.countryCodeLabel": "كود الدولة",
  "crm.phoneLabel": "رقم الهاتف",
  "crm.phonePlaceholder": "201234567890",
  "crm.digitsLeft": "متبقي {{count}} أرقام",
  "crm.digitsLeftOne": "متبقي رقم واحد",
  "crm.enterMoreDigits": "أدخل {{count}} أرقام أخرى",
  "crm.enterMoreDigitsOne": "أدخل رقم واحد آخر",
  "crm.phoneValid": "✓",
  "crm.nameLabel": "اسم العميل",
  "crm.namePlaceholder": "أدخل اسم العميل",
  "crm.stageLabel": "المرحلة الأولية",
  "crm.addBtn": "إضافة للمتابعة",
  "crm.adding": "جاري الإضافة...",
  "crm.invalidPhone": "أدخل رقم هاتف صحيح ({{digits}} أرقام)",
  "crm.alreadyExists": "هذا الرقم موجود بالفعل في قائمة المحادثات",
  "crm.manualEntry": "إدخال يدوي",
  "crm.importCsv": "استيراد CSV",
  "crm.importCsvTitle": "استيراد عملاء من CSV",
  "crm.importCsvDesc": "ارفع ملف CSV يحتوي على بيانات العملاء لإضافتهم دفعة واحدة إلى الـ Pipeline.",
  "crm.importCsvColumns": "الأعمدة المدعومة",
  "crm.importCsvColumnPhone": "الهاتف (مطلوب)",
  "crm.importCsvColumnName": "الاسم (اختياري)",
  "crm.importCsvColumnStage": "المرحلة (اختياري)",
  "crm.importCsvStageDefault": "الافتراضي: Lead جديد",
  "crm.importCsvStageOptions": "الخيارات المتاحة",
  "crm.importCsvDownloadTemplate": "تحميل قالب CSV",
  "crm.importCsvDropHere": "أسقط الملف هنا أو اضغط للرفع",
  "crm.importCsvCsvOnly": "ملفات CSV فقط",
  "crm.importCsvPreviewTitle": "معاينة ({{count}} عميل{{plural}})",
  "crm.importCsvNoValid": "لم يتم العثور على بيانات صالحة في الملف. تأكد من وجود عمود الهاتف.",
  "crm.importCsvWillImport": "سيتم استيراد {{count}} عميل{{plural}}",
  "crm.importCsvDuplicatesSkipped": "تم تخطي {{count}} مكرر{{plural}}",
  "crm.importCsvInvalidFile": "نوع ملف غير صالح. الرجاء رفع ملف .csv.",
  "crm.importCsvReadError": "فشل قراءة الملف. تأكد أنه ملف CSV صالح.",
  "crm.importCsvBtn": "استيراد {{count}} عميل{{plural}}",
  "crm.importCsvEmpty": "الملف فارغ أو لا يحتوي على بيانات صالحة.",
  "dashboard.tabs.crm": "CRM",

  // Catalog
  "dashboard.tabs.catalog": "الكتالوج",
  "catalog.title": "إدارة الكتالوج",
  "catalog.products": "منتجات",
  "catalog.cart": "السلة",
  "catalog.enableCart": "تفعيل السلة",
  "catalog.disableCart": "تعطيل السلة",
  "catalog.refresh": "تحديث",
  "catalog.tabProducts": "المنتجات",
  "catalog.tabCollections": "المجموعات",
  "catalog.searchProducts": "ابحث في المنتجات...",
  "catalog.allProducts": "كل المنتجات",
  "catalog.addProduct": "إضافة منتج",
  "catalog.noProducts": "لا توجد منتجات في الكتالوج",
  "catalog.addFirstProduct": "أضف منتجك الأول لبدء البيع",
  "catalog.noSearchResults": "لا توجد نتائج مطابقة",
  "catalog.noImage": "لا توجد صورة",
  "catalog.hidden": "مخفي",
  "catalog.edit": "تعديل",
  "catalog.show": "إظهار",
  "catalog.hide": "إخفاء",
  "catalog.delete": "حذف",
  "catalog.editProduct": "تعديل المنتج",
  "catalog.addProductBtn": "إضافة",
  "catalog.productName": "اسم المنتج",
  "catalog.productNamePlaceholder": "مثال: سماعات بلوتوث برو",
  "catalog.replaceImage": "استبدال الصورة",
  "catalog.productImage": "صورة المنتج",
  "catalog.clickToUpload": "انقر للرفع",
  "catalog.leaveEmptyToKeep": "اترك فارغاً للاحتفاظ بالصورة الحالية",
  "catalog.description": "الوصف",
  "catalog.descriptionPlaceholder": "وصف المنتج",
  "catalog.price": "السعر",
  "catalog.pricePlaceholder": "مثال: 299.99",
  "catalog.currency": "العملة",
  "catalog.productUrl": "رابط المنتج",
  "catalog.productUrlPlaceholder": "https://example.com/product",
  "catalog.retailerId": "معرف التاجر (SKU)",
  "catalog.retailerIdPlaceholder": "SKU001",
  "catalog.cancel": "إلغاء",
  "catalog.saveChanges": "حفظ التغييرات",
  "catalog.productAdded": "تم إضافة المنتج بنجاح",
  "catalog.productAddFailed": "فشل إضافة المنتج",
  "catalog.productUpdated": "تم تحديث المنتج",
  "catalog.productUpdateFailed": "فشل تحديث المنتج",
  "catalog.productDeleted": "تم حذف المنتج",
  "catalog.productDeleteFailed": "فشل حذف المنتج",
  "catalog.productShown": "تم إظهار المنتج",
  "catalog.productHidden": "تم إخفاء المنتج",
  "catalog.visibilityFailed": "فشل تغيير الظهور",
  "catalog.confirmDeleteProduct": "حذف المنتج؟",
  "catalog.confirmDeleteCollection": "حذف المجموعة؟",
  "catalog.cannotUndo": "لا يمكن التراجع عن هذا الإجراء.",
  "catalog.confirmDelete": "تأكيد الحذف",
  "catalog.collectionCount": "{{count}} مجموعة",
  "catalog.createCollection": "إنشاء مجموعة",
  "catalog.noCollections": "لا توجد مجموعات",
  "catalog.createFirstCollection": "أنشئ مجموعة لتنظيم منتجاتك",
  "catalog.collectionName": "اسم المجموعة",
  "catalog.collectionNamePlaceholder": "مثال: إلكترونيات",
  "catalog.selectProducts": "اختر المنتجات",
  "catalog.noProductsForCollection": "لا توجد منتجات متاحة",
  "catalog.createCollectionBtn": "إنشاء",
  "catalog.collectionCreated": "تم إنشاء المجموعة",
  "catalog.collectionCreateFailed": "فشل إنشاء المجموعة",
  "catalog.collectionUpdated": "تم تحديث المجموعة",
  "catalog.collectionUpdateFailed": "فشل تحديث المجموعة",
  "catalog.collectionDeleted": "تم حذف المجموعة",
  "catalog.collectionDeleteFailed": "فشل حذف المجموعة",
  "catalog.productsInCollection": "{{count}} منتج",
  "catalog.editCollection": "تعديل المجموعة",
  "catalog.cartToggleFailed": "فشل تغيير حالة السلة",
  "bulk.sendingActive": "حملة إرسال جماعي نشطة",
  "bulk.campaignScheduledShort": "إرسال مجدول",
  "bulk.scheduledFor": "مجدول في",
  "bulk.view": "عرض",
  "bulk.stopCampaign": "إيقاف",
  "bulk.sendingProgress": "تقدم الإرسال",
};

export default dashboard;